<template>
    <div class="service terms mw1260" style="overflow: scroll">
        <div class="term-wrap">
            <div class="policy-container">
                <div :value="termsType" class="tab policy-div">
                    <button value="stipulation"  @click="changeTerms('stipulation')"
                            class="policy-btn"
                            :class="{'active' : termsType === 'stipulation'}">
                        서비스이용약관
                    </button>
                    <button value="privacy"  @click="changeTerms('privacy')"
                            class="policy-btn"
                            :class="{'active' : termsType === 'privacy'}" >
                        개인정보처리방침
                    </button>
                </div>

                <div class="policy-content">
                        <el-select v-model="langOption" class="select ml5 float_right">
                            <el-option :value="0" :label="'Language'"></el-option>
                            <el-option :value="language.c_idx" :label="language.c_lang" v-for="language in languageList"
                                       :key="language.c_idx"></el-option>
                        </el-select>
                    <div class="clear"></div>
                    <terms-component :termsType="termsType" :type="langOption"></terms-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TermsComponent from "@/components/terms/TermsComponent";
    import languageList from "../../mixins/languageList";
    export default {
        name: 'Policy',
        mixins: [languageList],
        components: {
            TermsComponent
        },
        props: {
        },
        data() {
            return{
                termsType: 'stipulation',
                langOption:0,
            }
        },
        beforeRouterEnter() {},
        created() {
            this.getLanguage();
        },
        mounted() {

        },
        beforeDestroy() {

        },
        destroyed() {},
        computed: {
        },
        methods:{
            changeTerms(type) {
                this.termsType = type;
                this.langOption=0;
            },
        },
        watch: {

        },
    }
</script>
